<template>

    <div class="card has-background-grey-dark">
        <div class="columns is-mobile m-0">
            <div :class="'column is-half digitalOrPhysicalButton l ' + (digitalOrPhysical === 'digital' ? 'selected' : '') " @click=" () => {digitalOrPhysical = 'digital'} ">eGift Card <p>Emailed or Printed</p></div>
            <div :class="'column is-half digitalOrPhysicalButton r ' + (digitalOrPhysical === 'physical' ? 'selected' : '') " @click=" () => {digitalOrPhysical = 'physical'} ">Gift Card <p>Purchased at Xerocraft</p></div>
        </div>


        <div class="card-content has-text-white">

            <input type="hidden" v-model="digitalOrPhysical" name="digitalOrPhysical">

            <template v-if=" digitalOrPhysical === 'digital' ">
                <h3 class="px-5 title is-3 my-4 has-text-white has-text-centered">Give eGift Card</h3>

                <div class="field is-horizontal">
                    <div class="field-label">
                        <label for="customAmountD" class="label has-text-white">Gift Card Size</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control has-icons-left is-expanded">
                                <xero-input type="number" id="customAmountD" class="input" name="size" min="1" step="1" v-model=" chosenSize "/>
                                <span class="icon is-small is-left"><i class="fas fa-dollar-sign"></i></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label">
                        <label for="quantity" class="label required has-text-white">Quantity</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control has-icons-left is-expanded">
                                <div class="select is-fullwidth">
                                    <xero-select required name="quantity" id="quantity"
                                                 :options="{
                                        1: 1,
                                        2: 2,
                                        3: 3,
                                        4: 4,
                                        5: 5,
                                        6: 6,
                                        7: 7,
                                        8: 8,
                                        9: 9,
                                        10: 10,
                                     }"
                                                 :apply-classes="{
                                        '*': 'is-fullwidth',
                                     }"
                                                 :default-option="1">
                                    </xero-select>
                                </div>
                                <div class="icon is-small is-left">
                                    <i class="fas fa-hashtag"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label">
                        <label for="from" class="label required has-text-white">From</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control is-expanded has-icons-left">
                                <xero-input type="text" class="input" id="from" v-model="from" name="from" placeholder="Your Name, first name, nickname, etc." required />
                                <span class="icon is-left"><i class="fas fa-user"></i></span>
                            </p>
                            <p class="help">NOTE: This is the name that will appear on the gift card as the purchaser.</p>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label">
                        <label for="to" class="label required has-text-white">To</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control is-expanded has-icons-left">
                                <xero-input type="text" class="input" id="to" v-model="to" name="to" placeholder="Who is this for? Name, nickname, etc." />
                                <span class="icon is-left"><i class="fas fa-user"></i></span>
                            </p>
                            <p class="help">NOTE: This is the name that will appear on the gift card as the recipient.</p>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label">
                        <label for="email" class="label required has-text-white">Email To</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control is-expanded has-icons-left">
                                <email type="text" class="input" id="email" v-model="email" name="email" placeholder="Recipient's Email Address" required></email>
                                <span class="icon is-left"><i class="fas fa-envelope-open"></i></span>
                            </p>
                            <p class="help">NOTE: This is the email that the gift cards will be sent to!</p>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label">
                        <label for="message" class="label has-text-white">Message (optional)</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control is-expanded">
                                <xero-textarea class="textarea" name="message" v-model="message" maxlength="250" id="message" placeholder="(optional) Include a message with the gift card." rows="5"></xero-textarea>
                            </p>
                            <p class="help has-text-right">Characters Remaining: {{ 250 - message.length }}</p>
                        </div>
                    </div>
                </div>


            </template>
            <template v-if=" digitalOrPhysical === 'physical' ">
                <h3 class="px-5 title is-3 my-4 has-text-white has-text-centered">Activate Gift Card</h3>

                <div class="field">
                    <label for="customAmountP" class="label has-text-white">Gift Card Size</label>
                    <div class="control has-icons-left is-expanded">
                        <xero-input type="number" id="customAmountP" class="input" name="size" min="1" step="1" v-model=" chosenSize "/>
                        <span class="icon is-small is-left"><i class="fas fa-dollar-sign"></i></span>
                    </div>
                </div>

                <div class="field">
                    <label :for=" 'code'+_uid " class="label has-text-white">Provide the Gift Card's Code</label>
                    <div class="field has-addons">
                        <div class="control has-icons-left is-expanded">
                            <xero-input name="code" v-model="code" :class="'input '+(codeSuccess ? 'is-success' : '')" :uppercase="true" />
                            <span class="icon is-small is-left"><i class="fas fa-tag"></i></span>
                        </div>
                        <button type="button" class="button" @click=" () => {$modal.show('qr-code-reader')} " aria-label="QR Code Reader Option">
                            <span class="icon"><img :src=" $store.state.assetRoute + '/images/QR-Code-Reader-Icon.png' " alt="QR Code Reader Icon"></span>
                            &nbsp; SCAN
                        </button>
                    </div>
                    <p class="help">If you're giving a member one of our plastic gift cards, then you can find this code on the back of the gift card.</p>
                    <p class="help">If a custom gift card is being used , then put the unique code here to check if it's available and to activate it.</p>
                </div>
            </template>

        </div>


        <modal
            name="qr-code-reader"
            :adaptive="true"
            :width="'90%'"
            :height="'auto'">
            <div class="p-2 has-text-dark">
                <button type="button" class="delete" aria-label="close qr code reader window" @click=" () => {$modal.hide('qr-code-reader')} "></button>
                <h3 class="title is-3 has-text-dark has-text-centered">Scan Gift Card QR Code</h3>
            </div>

            <qrcode-stream @decode=" onQRDecode "></qrcode-stream>
        </modal>

        <div class="is-divider"></div>

        <div class="m-4 has-text-centered">
            <button class="button is-primary" type="submit">Submit</button>
        </div>
    </div>

</template>

<script>

import {QrcodeStream} from 'vue-qrcode-reader'

export default {
    name: 'Give-Gift-Card',
    data() {
        return {
            digitalOrPhysical: 'digital',
            from: '',
            to: '',
            email: '',
            message: '',
            chosenSize: 0,
            quantity: 1,
            user_name: '',
            user_email: '',
            code: '',
            codeFromQr: '',
            codeSuccess: false,
        };
    },
    methods: {
        onQRDecode: function (code) {
            if (code) {
                this.code = code;
                this.$modal.hide('qr-code-reader');
            }
        },
    },
    components: {
        QrcodeStream
    }
}
</script>

<style scoped lang="scss">

    textarea.textarea::placeholder {
        color: #b5b5b5;
    }

    .digitalOrPhysicalButton {
        outline: none;
        border: none;
        padding: 2em 0;
        font-size: 2em;
        text-align: center;
        background: #626262;
        font-weight: bold;
        color: #a1a1a1;
        cursor: pointer;
        transition-duration: .3s;
        transition-property: background-color,border-color,color;
        transition-timing-function: ease;

        &:hover {
            background: #6c6c6c;
            color: #f38135;

            & p {
                color: #f38135;
            }
        }
        &:active {
            background: #7f7f7f;
        }

        & p {
            font-size: 0.5em;
            font-weight: normal;
        }

        &.selected {
            background: #4a4a4a;
            color: #f38135;

            & p {
                color: whitesmoke;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .digitalOrPhysicalButton {
            font-size: 1.5em;
        }
    }

</style>
